<template>
  <div>
    <div class="homework-section-block profile-block rounded-5">
      <div
        class="title-row d-flex justify-content-between align-items-center nowrap"
      >
        <!-- TITLE -->
        <div
          class="title-bold color_text text-uppercase"
          v-if="account_type !== 'parent'"
        >
          Assessment
        </div>
        <div class="title-bold color_text text-uppercase" v-else>
          Schoolwork history
        </div>

        <!-- COMPLETION RATE -->
        <template
          v-if="account_type === 'parent' || account_type === 'student'"
        ></template>
        <div
          class="completion-rate d-flex flex-column justify-content-center align-items-end"
          v-else
        >
          <div class="text text-right color_grey_dark">
            Completion Rate: {{ completion_rate }}%
          </div>
          <!-- PROGRESS BAR -->
          <div class="progress">
            <div
              class="progress-bar"
              :class="rate_color"
              :style="'width:' + completion_rate + '%'"
              role="progress"
            ></div>
          </div>
        </div>
      </div>

      <!-- HOMEWORK DATA COMPONENT -->
      <div v-if="homework_list.length > 0">
        <HomeworkBlock
          :assessment_id="Number(homework.homework_id)"
          :date="homework.created_at"
          :close_date="homework.childHomework.close_date"
          :submit="Number(homework.submit)"
          :title="homework.childHomework.title"
          :subject="homework.subject.name"
          :percent="Math.round(Number(homework.score))"
          :type="homework.type"
          :teacher_id="homework.teacher_id"
          v-for="(homework, index) in homework_list"
          :key="index"
        ></HomeworkBlock>
      </div>

      <div
        class="d-flex justify-content-center align-items-center flex-wrap color_ash font-14"
        v-else
      >
        No Homework Available
      </div>

      <!-- HOMEWORK DATA COMPONENT -->

      <!-- SHOW MORE -->
      <div class="show-more" v-if="show_more">
        <div
          class="btn-link font-weight-bold"
          @click="showMoreHomwork"
          v-if="account_type !== 'parent'"
        >
          Show {{ text_addon }}
        </div>
        <div class="btn-link font-weight-bold" @click="showMoreHomwork" v-else>
          See {{ text_addon }} Homework
        </div>
      </div>
      <!-- SHOW MORE -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeworkSection",

  props: ["completion_rate", "homeworks"],

  components: {
    HomeworkBlock: () =>
      import(
        /* webpackChunkName: "HomeworkBlock" */ "@/components/profileComps/studentprofile/HomeworkBlock"
      ),
  },

  watch: {
    homeworks: {
      handler(newVal) {
        if (newVal) this.loadHomework();
      },
      immediate: true,
    },
  },

  data() {
    return {
      account_type: "",
      rate_color: "",

      base_homework_list: [],
      homework_list: [],
      shrinked: true,
      text_addon: "",
      show_more: false,
    };
  },

  mounted() {
    this.getAccountType();
    this.setCompletion();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    setCompletion() {
      if (this.completion_rate >= 75) this.rate_color = "brand_green_bg";
      else if (this.completion_rate >= 45 && this.completion_rate <= 74)
        this.rate_color = "brand_accent_bg";
      else if (this.completion_rate <= 44) this.rate_color = "brand_red_bg";
    },

    loadHomework() {
      // console.log(this.homeworks);
      this.base_homework_list = this.homeworks.slice().reverse();
      this.homework_list = this.homeworks.slice().reverse();
      if (this.homework_list.length > 4) {
        this.show_more = true;
        this.text_addon = "More";
        this.homework_list = this.homework_list.slice(0, 4);
      } else this.show_more = false;
    },

    showMoreHomwork() {
      this.shrinked = !this.shrinked;
      if (this.shrinked) {
        if (this.homework_list.length > 4)
          this.homework_list = this.homework_list.slice(0, 4);
        this.text_addon = "More";
      } else {
        this.homework_list = this.base_homework_list;
        this.text_addon = "Less";
      }
    },
  },
};
</script>

<style lang="scss">
.homework-section-block {
  .title-row {
    margin-top: 8px;
    margin-bottom: 31px;

    @include breakpoint_max(xs) {
      margin-bottom: 25px;
    }

    .title-bold {
      @include breakpoint_max(xs) {
        font-size: 14px !important;
      }
    }

    .text {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 5px;

      @include breakpoint_max(xs) {
        font-size: 11px;
      }
    }

    .progress {
      width: 150%;

      @include breakpoint_max(xs) {
        width: 100%;
      }
    }
  }
}
</style>
